<template>
  <section id="tracking-information">
    <div v-if="tracking.stage" id="tracking-found">
      <h2>Step {{tracking.stage}} - {{getStageName()}}</h2>
      <p id="tracking-datetime">{{tracking.dateTime}}</p>
      <p id="tracking-message">{{tracking.message}}</p>
      <p v-if="tracking.neighbourInfo !== 'null'" id="tracking-neighbour-info">The tracking indicates the parcel has been left at '{{tracking.neighbourInfo}}'</p>

      <img id="proof_image" v-for="image in tracking.proofImages" :src="image.src" :alt="image.type">

      <img id="tracking_image" :src="tracking.geo" v-if="tracking.geo !== 'null'">
    </div>

    <input type="hidden" id="uuid" name="uuid" v-model="tracking.uuid">
    <input type="hidden" name="trackingStage" v-model="tracking.stage">
    <input type="hidden" name="trackingStageDescription" v-model="tracking.stageDescription">
    <input type="hidden" name="trackingMessage" v-model="tracking.message">
    <input type="hidden" name="trackingPoint" v-model="tracking.trackingPoint">
    <input type="hidden" name="trackingPointId" v-model="tracking.trackingPointId">

    <section v-if="tracking.existingEnquiry" id="tracking-existing-enquiry">

      <input type="hidden" id="existingRef" name="existingRef" v-model="tracking.existingEnquiry.ref">
      <p>It looks like we have already been contacted about this parcel and are working to resolve it. See incident details below.</p>
<p>Ref: {{tracking.existingEnquiry.ref}}</p>
<p>Status: <b id="existingEnquiryStatus">{{tracking.existingEnquiry.status}}</b></p>
<pre style="white-space: pre-wrap;"><div id="existing-enquiry-message" v-html="tracking.existingEnquiry.message.trim()"></div></pre><br />
      <div v-if="tracking.customerEnquiry" id="tracking-customer-enquiry">
        <p style="font-weight:bold;">Note that the customer has already contacted us about this parcel</p>
        <p>Customer created enquiry on: <b>{{tracking.customerEnquiry.timestamp}}</b></p>
        <p>Status of customer's enquiry: <b>{{tracking.customerEnquiry.status}}</b></p>
      </div >
      <input type="hidden" name="cpmAction" v-model="tracking.existingEnquiry.cpmAction">
      <router-link class="secondary-button" id="link_existing-enquiry-waiting" to="/wait-for-existing-enquiry">I'll wait for a response from Evri for the original enquiry</router-link>
      <router-link class="secondary-button" id="link_existing-enquiry-chasing" to="/chase-existing-enquiry" v-if="shouldShowChaseButton()">I'm chasing a response for this enquiry</router-link>
      <router-link class="secondary-button" id="link_existing-enquiry-updating" to="/update-existing-enquiry">I would like to update the original enquiry</router-link>
    </section>
    <br/>
    <div v-if="tracking.customerEnquiry && !tracking.existingEnquiry" id="tracking-customer-enquiry">
      <p style="font-weight:bold;">Note that the customer has already contacted us about this parcel</p>
      <p>Customer created enquiry on: <b>{{tracking.customerEnquiry.timestamp}}</b></p>
      <p>Status of customer's enquiry: <b>{{tracking.customerEnquiry.status}}</b></p>
    </div >
    <div v-if="!tracking.existingEnquiry || tracking.existingEnquiry.status == 'Solved' || tracking.existingEnquiry.status == 'Client: Solved'">
      <p>{{getRaiseEnquiryMessage()}}</p>
      <router-link class="secondary-button" id="link_tracking-information_collection-enquiry" to="/collection-enquiry" v-if="isDomesticStage('1', '5', '6') || getTrackingOverride()">Collection Enquiry</router-link>
      <router-link class="secondary-button" id="link_tracking-information_delivery-enquiry" to="/delivery-enquiry" v-if="(!tracking.international && !isDomesticStage('1')) || getTrackingOverride()">Delivery Enquiry</router-link>
      <router-link class="secondary-button" id="link_tracking-information_something-else" to="/something-else" v-if="isDomesticStage('4', '5', '6') || getTrackingOverride()">It's about something else</router-link>
      <router-link class="secondary-button" id="link_tracking-information_international" to="/international" v-if="tracking.international || getTrackingOverride()">International Enquiry</router-link>
    </div>
  </section>
</template>

<script>
export default {
  props: ['tracking'],
  methods: {
    getStageName() {
      switch (this.tracking.trackingPoint) {
        case 'VAN_HELD_LOCKER_FULL':
        case 'VAN_HELD_LOCKER_ACCESS_PROBLEM':
        case 'VAN_HELD_LOCKER_TECHNICAL_ISSUE':
        case 'RETURN_SENDER_TOOLARGE':
        case 'NOT_DELIVERED_TO_SHOP_LARGE':
        case 'NOT_DELIVERED_TO_SHOP_DAMAGED':
        case 'DRIVER_COLLECTED_EXPIRED_PARCEL':
          return 'Update on your parcel';
        case 'COURIER_DELIVERED_TO_LOCKER':
        case 'RECEIVED_AT_LOCKER':
        case 'COLLECT_FROM_PARCELSHOP':
        case 'COLLECT_FROM_PSHOP_LOCKER':
          return 'Delivered to shop or locker';
        case 'COLLECTED_PIN':
          return 'Collected';
        case 'DELIVERING_TO_PARCELSHOP':
          return 'On its way';
        default:
          const names = ['We\'ve not got it', 'We\'ve got it', 'On it\'s way', 'With your courier', 'Delivered', 'Exception'];
          return names[this.tracking.stage - 1];
      }
    },
    shouldShowChaseButton() {
      return this.$store.state.updIncidentSolvedStatuses.indexOf(this.tracking.existingEnquiry.status) === -1;
    },
    isDomesticStage(...stages) {
      return !this.tracking.international && stages.indexOf(this.tracking.stage) !== -1
    },
    getRaiseEnquiryMessage() {
      return this.tracking.existingEnquiry ? "If you need to raise a new enquiry, please select from the following options" : "If you need to raise an enquiry, please select from the following options"
    },
    getTrackingOverride() {
      return this.$store.state.overrideTracking
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TrackingInformation.vue